var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6808 6.55C23.3808 5.5 22.6308 4.75 21.5808 4.45C19.7808 4 12.1308 4 12.1308 4C12.1308 4 4.63077 4 2.68077 4.45C1.63077 4.75 0.880757 5.5 0.580757 6.55C0.280757 8.5 0.280762 12.4 0.280762 12.4C0.280762 12.4 0.280766 16.3 0.730766 18.25C1.03077 19.3 1.78076 20.05 2.83076 20.35C4.63076 20.8 12.2808 20.8 12.2808 20.8C12.2808 20.8 19.7807 20.8 21.7307 20.35C22.7807 20.05 23.5308 19.3 23.8308 18.25C24.2808 16.3 24.2808 12.4 24.2808 12.4C24.2808 12.4 24.2808 8.5 23.6808 6.55ZM9.88075 16V8.8L16.1808 12.4L9.88075 16Z",
    fill: "#000033"
  })));
};
export default SvgYoutube;